import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import esLocale from 'date-fns/locale/es';
import TextField from '@mui/material/TextField';

import classes from './Calendar.module.scss';

const Calendar = ({ value, onChange, format, name, ...props }) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
      <DatePicker
        //className={classes.tamano}
        value={value}
        onChange={newValue => {
          onChange(newValue);
        }}
        renderInput={props => <TextField {...{ ...props, name }} className={classes.tamano} />}
        inputFormat={format ? format : 'dd/MM/yyyy'}
        {...props}
      />
    </LocalizationProvider>
  );
};

export default Calendar;
